'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _reject2 = require('lodash/reject');

var _reject3 = _interopRequireDefault(_reject2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.isLoadTime = isLoadTime;
exports.loadPlaylists = loadPlaylists;
exports.loadPress = loadPress;
exports.loadTracks = loadTracks;
exports.reorder = reorder;
exports.toggleView = toggleView;
exports.deletePlaylist = deletePlaylist;
exports.setTypeFilter = setTypeFilter;
exports.filter = filter;

var _loadReducer = require('../loadReducer');

var _loadReducer2 = _interopRequireDefault(_loadReducer);

var _playstats = require('./playstats');

var _auth = require('./auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ORDER = 'playlists/ORDER'; /* Playlists (albums) redux reducer and action creators */

var TOGGLE_VIEW = 'playlists/TOGGLE_VIEW';
var SET_TYPE_FILTER = 'playlists/SET_TYPE_FILTER';
var FILTER = 'playlists/FILTER';

var loadReducer = (0, _loadReducer2.default)('playlists', {
  playlists: { action: 'load', init: { albums: [], tracks: {} } },
  press: { action: 'load', init: null },
  tracks: { action: 'load', init: null },
  deletePlaylist: { init: {} }
});

var initialState = (0, _extends4.default)({}, loadReducer.initialState, {
  order: {
    artist_name: 'asc',
    sent_date: 'desc',
    sender: 'asc',
    label_name: 'asc',
    releaseDate: 'desc'
  },
  activeOrder: 'sent_date',
  showGroups: false,
  orders: [{ name: 'artist_name', title: 'Artist' }, { name: 'sent_date', title: 'Date' }, { name: 'sender', title: 'Sender' }, { name: 'label_name', title: 'Label' }, { name: 'releaseDate', title: 'Release Date' }],
  viewType: 'grid',
  typeFilter: '',
  kw: '',
  displayInfo: {}
});

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'RESET':
      return initialState;
    case ORDER:
      return (0, _extends4.default)({}, state, {
        order: (0, _extends4.default)({}, state.order, (0, _defineProperty3.default)({}, action.name, state.activeOrder === action.name ? state.order[action.name] === 'asc' ? 'desc' : 'asc' : state.order[action.name])),
        showGroups: action.name !== 'sent_date',
        activeOrder: action.name
      });
    case TOGGLE_VIEW:
      return (0, _extends4.default)({}, state, {
        viewType: state.viewType === 'grid' ? 'list' : 'grid'
      });
    case SET_TYPE_FILTER:
      return (0, _extends4.default)({}, state, {
        typeFilter: action.typeFilter
      });
    case loadReducer.constants.LOAD_PLAYLISTS:
      return (0, _extends4.default)({}, loadReducer.reducer(state, action), {
        typeFilter: action.typeFilter
      });
    case loadReducer.constants.LOAD_PLAYLISTS_SUCCESS:
      return (0, _extends4.default)({}, loadReducer.reducer(state, action), {
        typeFilter: action.typeFilter,
        displayInfo: action.result.data.displayInfo
      });
    case loadReducer.constants.DELETE_PLAYLIST_SUCCESS:
      {
        var albums = state.playlistsData.albums;

        return (0, _extends4.default)({}, state, {
          playlistsData: (0, _extends4.default)({}, state.playlistsData, {
            albums: (0, _reject3.default)(albums, { contentKey: action.key })
          })
        });
      }
    case FILTER:
      return (0, _extends4.default)({}, state, {
        kw: action.kw
      });
    default:
      return loadReducer.reducer(state, action);
  }
}

function isLoaded() {
  return function (dispatch, getState) {
    return (0, _get3.default)(getState(), 'playlists.playlistsLoaded');
  };
}

function isLoadTime() {
  return function (dispatch, getState) {
    var state = getState();
    return !(0, _get3.default)(state, 'playlists.playlistsLoaded') && !(0, _get3.default)(state, 'auth.user');
  };
}

function loadPlaylists(type) {
  var data = { type: type !== 'all' ? type : undefined };

  return function (dispatch) {
    return dispatch({
      types: loadReducer.constantsByKey.playlists,
      promise: function promise(client) {
        var result = client.post('viewer_wa/playlists', { data: data });
        result.promise.then(function (resp) {
          dispatch((0, _playstats.setData)({ albums: resp.data.albums, albumsTracks: resp.data.tracks }));
          return resp;
        }).catch(function (err) {
          return err;
        });
        return result;
      },
      typeFilter: type
    });
  };
}

function loadPress(_ref) {
  var key = _ref.key;

  return function (dispatch) {
    var data = { key: key };
    var isUser = dispatch((0, _auth.isLoggedIn)());
    return dispatch({
      types: loadReducer.constantsByKey.press,
      promise: function promise(client) {
        return client.post(isUser ? 'viewer_wa/downloadPress' : 'auth/downloadPressFromKey', { data: data });
      }
    });
  };
}

function loadTracks(projectId, recipientId) {
  var data = { project_id: projectId, recipient_id: recipientId };
  return {
    types: loadReducer.constantsByKey.tracks,
    promise: function promise(client) {
      return client.post('viewer_wa/album_tracks', { data: data });
    }
  };
}

function reorder(name) {
  return {
    type: ORDER,
    name: name
  };
}

function toggleView() {
  return {
    type: TOGGLE_VIEW
  };
}

function deletePlaylist(_ref2) {
  var key = _ref2.key;

  var data = { key: key };
  return {
    types: loadReducer.constantsByKey.deletePlaylist,
    promise: function promise(client) {
      return client.post('viewer_wa/delete', { data: data });
    },
    key: key
  };
}

function setTypeFilter(typeFilter) {
  return {
    type: SET_TYPE_FILTER,
    typeFilter: typeFilter
  };
}

function filter() {
  var kw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return {
    type: FILTER,
    kw: kw
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/playlists.js
// module id = 100
// module chunks = 1